(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4019],{

/***/ 17285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 49546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _ampContext = __webpack_require__(17285);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react["default"].useContext(_ampContext.AmpStateContext));
}

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 16505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__(930);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _sideEffect = _interopRequireDefault(__webpack_require__(70148));

var _ampContext = __webpack_require__(17285);

var _headManagerContext = __webpack_require__(60523);

var _amp = __webpack_require__(49546);

var _utils = __webpack_require__(67206);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headElements List of multiple <Head> instances
 */


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react["default"].Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !props.inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _objectSpread({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 70148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__(7980);

var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _assertThisInitialized = __webpack_require__(92191);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var isServer = false;

var _class = /*#__PURE__*/function (_react$Component) {
  _inherits(_class, _react$Component);

  var _super = _createSuper(_class);

  function _class(props) {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this, props);

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances["delete"](this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _class;
}(_react.Component);

exports["default"] = _class;

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 70939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ video; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Video/index.tsx


var Video = function Video(_ref) {
  var title = _ref.title,
      src = _ref.src;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Iframe, {
    title: title,
    src: src,
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  });
};
var Iframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "Video__Iframe",
  componentId: "sc-1ifsscc-0"
})(["height:202px;width:316px;@media screen and (max-width:1047px){width:350px;height:224px;}"]);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/News/Video/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var VideoPage = function VideoPage(_ref) {
  var videoInfoList = _ref.videoInfoList;
  var pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: 'ニュースルーム',
    path: '/news'
  }, {
    name: 'ビデオライブラリー',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u30D3\u30C7\u30AA\u30E9\u30A4\u30D6\u30E9\u30EA\u30FC",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u30D3\u30C7\u30AA\u3092\u3054\u8996\u8074\u3044\u305F\u3060\u3051\u307E\u3059\u3002",
      ogp: {
        type: 'article',
        url: 'news/video/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
      breadCrumbs: breadCrumbs,
      isRequiredBackground: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          titleText: "Video Library",
          subTitleText: "\u30D3\u30C7\u30AA\u30E9\u30A4\u30D6\u30E9\u30EA\u30FC",
          color: "normal"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 50,
            pc: 63
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoryTitle, {
          children: "\u6226\u7565\u7D39\u4ECB\u52D5\u753B"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 40,
            pc: 52
          }
        }), videoInfoList.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(VideoList, {
          children: videoInfoList.map(function (_ref2) {
            var title = _ref2.title,
                url = _ref2.url;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(VideoItem, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Video, {
                title: title,
                src: url
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(VideoTitle, {
                children: title
              })]
            }, url);
          })
        })]
      })
    }))]
  });
};
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Video__Container",
  componentId: "sc-1r5cqbo-0"
})(["width:1040px;padding:70px 0 130px;margin:0 auto;@media screen and (max-width:1047px){padding:40px 20px 80px;width:100%;}"]);
var CategoryTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
  displayName: "Video__CategoryTitle",
  componentId: "sc-1r5cqbo-1"
})(["font-size:28px;font-weight:bold;letter-spacing:1.68px;line-height:42px;color:", ";@media screen and (max-width:1047px){font-size:20px;letter-spacing:1.2px;line-height:28px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var VideoItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Video__VideoItem",
  componentId: "sc-1r5cqbo-2"
})(["width:316px;@media screen and (max-width:1047px){width:350px;}"]);
var VideoList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Video__VideoList",
  componentId: "sc-1r5cqbo-3"
})(["display:flex;flex-wrap:wrap;gap:46px;"]);
var VideoTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Video__VideoTitle",
  componentId: "sc-1r5cqbo-4"
})(["font-size:16px;letter-spacing:1.6px;line-height:22px;color:", ";margin-top:14px;@media screen and (max-width:1047px){letter-spacing:0.96px;margin-top:10px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
;// CONCATENATED MODULE: ./src/pages/news/video.tsx



var video_Video = function Video(_ref) {
  var videoList = _ref.videoList;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(VideoPage, {
    videoInfoList: videoList[0].strategy
  });
};

var __N_SSG = true;
/* harmony default export */ var video = (video_Video);

/***/ }),

/***/ 37072:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/video",
      function () {
        return __webpack_require__(70939);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,5548,9774,2888,179], function() { return __webpack_exec__(37072); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);